import { Injectable } from "@angular/core";
import io from "socket.io-client";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
// Online counter service for tracking user connections by business
export class OnlineCounterService {
    socket: any;

      constructor() {
        this.socket = io(environment.urlonlinecountersocket, {
            withCredentials: false
        });
    }

    connect(userName: string, email: string, password: string): void {
        this.socket.emit("set-user", userName, email, password);
    }

    disconnect(): void {
        this.socket.emit("logout");
    } 
} 
